/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItMeasurementPropertyFilterDto } from './TrackItMeasurementPropertyFilterDto';
import {
    TrackItMeasurementPropertyFilterDtoFromJSON,
    TrackItMeasurementPropertyFilterDtoFromJSONTyped,
    TrackItMeasurementPropertyFilterDtoToJSON,
} from './TrackItMeasurementPropertyFilterDto';

/**
 * 
 * @export
 * @interface GetSuggestedTrackItMeasurementPropertyFiltersRequestDto
 */
export interface GetSuggestedTrackItMeasurementPropertyFiltersRequestDto {
    /**
     * 
     * @type {Array<TrackItMeasurementPropertyFilterDto>}
     * @memberof GetSuggestedTrackItMeasurementPropertyFiltersRequestDto
     */
    previousFilters?: Array<TrackItMeasurementPropertyFilterDto> | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuggestedTrackItMeasurementPropertyFiltersRequestDto
     */
    $type?: GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoTypeEnum;
}


/**
 * @export
 */
export const GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoGetSuggestedTrackItMeasurementPropertyFiltersRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.GetSuggestedTrackItMeasurementPropertyFiltersRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoTypeEnum = typeof GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoTypeEnum[keyof typeof GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoTypeEnum];



/**
 * Check if a given object implements the GetSuggestedTrackItMeasurementPropertyFiltersRequestDto interface.
 */
export function instanceOfGetSuggestedTrackItMeasurementPropertyFiltersRequestDto(value?: unknown): value is GetSuggestedTrackItMeasurementPropertyFiltersRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoTypeEnum)[0];
}

export function GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoFromJSON(json: any): GetSuggestedTrackItMeasurementPropertyFiltersRequestDto {
    return GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoFromJSONTyped(json, false);
}

export function GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSuggestedTrackItMeasurementPropertyFiltersRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'previousFilters': json['previousFilters'] == null ? undefined : ((json['previousFilters'] as Array<any>).map(TrackItMeasurementPropertyFilterDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function GetSuggestedTrackItMeasurementPropertyFiltersRequestDtoToJSON(value?: GetSuggestedTrackItMeasurementPropertyFiltersRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'previousFilters': value['previousFilters'] == null ? undefined : ((value['previousFilters'] as Array<any>).map(TrackItMeasurementPropertyFilterDtoToJSON)),
        '$type': value['$type'],
    });
}

